<template>
  <div class="content" id="select_img">
    <p class="question_no">Q.{{ val }}</p>
    <p class="question_txt"  v-if="build === 'inner'">このお家の内観は好みですか？</p>
    <p class="question_txt"  v-if="build === 'outer'">このお家の外観は好みですか？</p>
    <p class="house_pho">
      <transition
        v-on:before-enter="beforeEnter"
        v-on:enter="enter"
        v-on:after-enter="afterEnter"
        v-on:enter-cancelled="enterCancelled"
        v-on:before-leave="beforeLeave"
        v-on:leave="leave"
        v-on:after-leave="afterLeave"
        v-on:leave-cancelled="leaveCancelled"
        v-bind:name="selectImg ? 'like' : 'umm'"
      >
        <img :src="quests[0].img" v-show="show" alt="" />
      </transition>
    </p>
  </div>
</template>
<script>
export default {
  name: "ImageSelect",
  props: {
    quests: {},
    val: {
      type: Number,
    },
    selectImg: {},
    show: {},
    build: String,
  },
  methods: {
    beforeEnter: function () {},
    enter: function () {},
    afterEnter: function () {},
    enterCancelled: function () {},
    beforeLeave: function () {},
    leave: function () {},
    afterLeave: function () {
      this.show = true;
    },
    leaveCancelled: function () {},
  },
};
</script>